import css from "styled-jsx/css";
import { grid } from "./constants";

export default css`
  .ecosystem {
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    background-color: black;

    .content {
      position: relative;
    }
  }

  // Tablet
  @media screen and (min-width: ${grid.breakpoint_sm}px) {
    .ecosystem {
      .content {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        margin-top: 5px;
        margin-bottom: 2rem;
      }
    }
  }

  // Desktop
  @media screen and (min-width: ${grid.breakpoint_md}px) {
  }
`;
